import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Un pannello delle analisi del bando della pagina Preparazione (ReadinessScore, ModuleChecklist di
// components/readiness, 31a5bd1): rilegge sé stesso da `url` (Readiness::AnalisiController#show, Turbo Stream con morph).
// - "analisi-info:mostra" {id, kind} (analisi_info_controller.js, «Apri» / «Torna all'ultima analisi»): solo del proprio
//   `kind`; ?storico=<id> mostra l'analisi precedente (il server la risolve con analisi_storico_voce), senza id l'ultima.
//   Il morph tiene aperto «Testo degli atti» (id stabile), come il componente di React che restava montato.
// - "analysis-poll:done" (onDone → onAnalisi: il progetto riletto): la pagina si rilegge (refresh con morph, stesso
//   indirizzo e action replace); i frame dello storico con refresh="morph" si ricaricano conservando lo stato dei riquadri.
// - "analysis-poll:error": il pannello riletto, con ?errore=analisi|tempo se `erroreInPannello` (il riquadro d'errore di
//   ReadinessScore); ModuleChecklist torna solo com'era. Se quella lettura non riesce (rete, risposta che non è un Turbo
//   Stream) il pannello resterebbe in attesa senza polling (il polling è già tolto): la pagina si rilegge, come React
//   che rimetteva sempre loading a false.
// Durante il polling (il pannello contiene analysis-poll) un morph della pagina non lo tocca (turbo:before-morph-element),
// così un'altra analisi finita prima non ferma questa: in React il caricamento era stato locale del componente.
// I toast dell'esito sono di analysis_poll_controller (doneToast, errorToast).
export default class extends Controller {
  static values = { url: String, kind: String, erroreInPannello: Boolean }

  connect() {
    this.trattieni = (event) => {
      if (event.target === this.element && this.inCorso()) event.preventDefault()
    }
    this.element.addEventListener("turbo:before-morph-element", this.trattieni)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-morph-element", this.trattieni)
  }

  inCorso() {
    return !!this.element.querySelector("[data-controller~='analysis-poll']")
  }

  mostra({ detail }) {
    if (!detail || detail.kind !== this.kindValue) return
    this.carica(detail.id ? { storico: detail.id } : {})
  }

  fatto(event) {
    event.target.remove()
    Turbo.visit(window.location.href, { action: "replace" })
  }

  errore(event) {
    event.target.remove()
    const tipo = event.detail?.error === "analysis-failed" ? "analisi" : "tempo"
    this.carica(this.erroreInPannelloValue ? { errore: tipo } : {}).then((ok) => {
      if (!ok) Turbo.visit(window.location.href, { action: "replace" })
    })
  }

  // Il pannello riletto; vero se è arrivato (Turbo Stream reso).
  async carica(extra) {
    const url = new URL(this.urlValue, window.location.origin)
    Object.entries(extra).forEach(([k, v]) => url.searchParams.set(k, v))
    try {
      const res = await fetch(url.toString(), { credentials: "same-origin", headers: { Accept: "text/vnd.turbo-stream.html" } })
      const testo = await res.text()
      if (!(res.headers.get("Content-Type") || "").includes("turbo-stream")) return false
      Turbo.renderStreamMessage(testo)
      return true
    } catch (_) {
      // rete non raggiungibile: il pannello resta com'è
      return false
    }
  }
}
